import type { BackendUser } from "types/interfaces/adminUsers";

export function getBackendUserPrimaryLabel(u: BackendUser): string {
  return (u.client_name || u.username).trim() || u.username;
}

/** Plain string for Autocomplete getOptionLabel (input + a11y). */
export function formatBackendUserOptionLabel(u: BackendUser): string {
  return `${getBackendUserPrimaryLabel(u)} @${u.username} (id: ${u.id})`;
}
